import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';
import { EthicsChannelReportType } from './enum/EthicsChannelReportType.enum';
import { EthicsChannelReportStatus } from './enum/EthicsChannelReportStatus.enum';
import { EthicsChannelReportInvestigation } from './enum/EthicsChannelReportInvestigation.enum';
import { ActionPlanModel } from '../action-plan/action-plan.model';

export class EthicsChannelReportModel extends Model implements IModel<EthicsChannelReportModel> {
  public companyFacilityId: string = '';
  public employeeId: string = '';
  public employeeName: string = '';
  public employeeRegistration: string = '';
  public employeeJobTitle: string = '';
  public type: string = '';
  public status: string = '';
  public formSubmissionId: string = '';
  public companyGroupId: string = '';
  public description: string = '';
  public deadline: string = '';
  public actionPlan: string = '';
  public anonymousReport: boolean = false;
  public employeeProfileImagePath: string = '';
  public criticality: string = null;
  public investigation: string = null;
  public employeeCompanyName: string = '';
  public companyFacilityName: string = '';
  public actions: ActionPlanModel[] = [];
  public classificationId: string = null;
  public classificationTitle: string = '';

  get typeBadge(): string {
    const type = EthicsChannelReportType.getBy(this.type);
    return `<span>${type?.label}</span>`;
  }

  get investigationLabel(): string {
    const type = EthicsChannelReportInvestigation.getBy(this.investigation);
    return type ? `<span>${type?.label}</span>` : 'Não Iniciada';
  }

  get statusBadge(): any {
    const status = EthicsChannelReportStatus.getBy(this.status) as EthicsChannelReportStatus;
    if (!status) return null;

    return {
      icon: status.icon,
      iconColor: status.iconColor,
      iconBackground: status.iconBackground,
      className: status.className,
      label: status.label,
    };
  }

  static create(input: any): EthicsChannelReportModel {
    return ObjectMapper.deserialize<EthicsChannelReportModel>(EthicsChannelReportModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
